
export const setFilterAplicates = (state,payload)=>{    
    state.filtersAplicates = payload
}
